import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from '../api.service';
import { catchError, Observable, switchMap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements HttpInterceptor {
constructor(private cookie: CookieService, private apiService: ApiService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const accessToken = this.cookie.get('access_token');

    if (req.url.endsWith('/auth/refresh')) {
    return next.handle(req);
    }

    let clonedReq = req;
    if (accessToken) {
      clonedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`
        }
      });
    }

    return next.handle(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Access token might be expired
          const refreshToken = this.cookie.get('refresh_token');
          if (refreshToken) {
            return this.apiService.refreshAccessToken(refreshToken).pipe(
              switchMap((newToken: string) => {
                this.cookie.set('access_token', newToken); // Save new token

                // Retry original request with new token
                const retryReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken}`
                  }
                });
                return next.handle(retryReq);
              })
            );
          }
        }
        return throwError(() => error);
      })
    );
  }
}
